import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"

// components
import AmenityLang from "./_langs";
import Separator from "../../../components/Separator";
import SelectGeneric from "../../../components/select/selectGeneric";
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";

// labels
import {PH_CODE, PH_ICON} from "../../../components/i18n/placeHolders"
import {LB_CODE, INTERNATIONAL, REQUIRED} from "../../../components/i18n/i18n"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {FL_CATEGORY, FL_ICON, FL_TYPE_AMENITY} from "../../../components/i18n/formLabels";

// services
import {amenityService} from "../../../jwt/_services/hotel/amenityService"

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {hotelCategoryProvider} from "../../../providers/hotelCategoryProvider";
import {amenityTypeProvider} from "../../../providers/amenityTypeProvider";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import TranslateButton from "../../../components/buttons/TranslateButton";





const AmenityForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { udn, app, editMode, domainObject} = componentState?.data;

    const fbDataBase = {id: app?.fbDataBase?.id}
    const translatableLangs = domainObject?.translatedLangs || []

    const [langs, setlangs] = useState(domainObject?.langs || []);
    const [amenityType, setAmenityType] = useState(domainObject?.type?.id);
    const [categoryId, setCategoryId] = useState(domainObject?.category?.id);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id      : domainObject?.id,
            uid     : domainObject?.uid,
            code    : domainObject?.code,
            icon    : domainObject?.icon,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                langs
            }
        };

        if(amenityType)
            dataRequest.item.type = { id:amenityType }

        if(categoryId)
            dataRequest.item.category = { id:categoryId }

        if (!editMode)
            genericIndexedActions.save(path, amenityService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, amenityService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }


    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                    udn={udn}
                />

                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                            <TranslateButton
                                item={domainObject}
                                service={amenityService}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{LB_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_CODE}
                                innerRef={register}
                            />
                            {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_ICON}</Label>
                            <Input
                                type="text"
                                name="icon"
                                placeholder={PH_ICON}
                                innerRef={register}
                            />
                            { errors.name && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.icon?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_CATEGORY }</Label>
                            <SelectGeneric
                                initialValue={categoryId}
                                setExternalValue={setCategoryId}
                                provider={hotelCategoryProvider}
                                getAllCategories={true}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_TYPE_AMENITY }</Label>
                            <SelectGeneric
                                initialValue={amenityType}
                                setExternalValue={setAmenityType}
                                provider={amenityTypeProvider}
                            />
                        </FormGroup>
                    </Col>
                </Row>


                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-language mr-2"/>
                    { INTERNATIONAL }
                </CardTitle>
                <CardBody>
                    <AmenityLang
                        langs={langs}
                        setLangs={setlangs}
                        translatableLangs={translatableLangs}
                    />
                </CardBody>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default AmenityForm